export { default as VideoGallery } from './VideoGallery';